<template>
  <main><JuryBlock :separatePage="true" v-bind="messages.jury" /></main>
</template>

<script>
import { PageMixin } from '~/mixins/PageMixin'
import { Head } from '~/mixins/Head'
import JuryBlock from '~/components/JuryBlock'

export default {
  computed: {
    metaObj() {
      return this.messages.jury.meta
    }
  },
  mixins: [PageMixin, Head],
  components: {
    JuryBlock
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// pages/jury.vue